import { HttpErrorResponse } from '@angular/common/http';
import { MatSnackBar } from '@angular/material/snack-bar';
import { APIResponse } from 'app/core/models/api.response.model';
import { catchError, delay, of, pipe, retry, tap } from 'rxjs';
import { SuccessSnackBarComponent } from '../components/snack-bars/success-snack-bar/success-snack-bar.component';
import { FailureSnackBarComponent } from '../components/snack-bars/failure-snack-bar/failure-snack-bar.component';
import * as Sentry from '@sentry/angular-ivy';


export class BaseApiService {
    constructor(matSnackBarImpl: MatSnackBar) {
        this.matSnackBar = matSnackBarImpl;
    }

    protected BASE_URL = "https://curelinktech.in";

    matSnackBar: MatSnackBar;

    protected errorHandler = catchError((errorResponse) => {
        Sentry.addBreadcrumb({
            level: 'error',
            type: "http",
            category: "xhr",
            message: 'API Exception',
            data: errorResponse,
        });
        if (
            errorResponse instanceof HttpErrorResponse &&
            (errorResponse.status === 400 || errorResponse.status === 409 || errorResponse.status === 429)
        ) {
            return of(errorResponse.error);
        }
        return of({
            success: false,
            message: 'Unknown Error',
        });
    });

    protected announceResponse = tap((response: APIResponse<any>) => {
        if (response.success) {
            this.matSnackBar.openFromComponent(SuccessSnackBarComponent, {
                data: {
                    message: response.message,
                },
            });
        } else {
            this.matSnackBar.openFromComponent(FailureSnackBarComponent, {
                data: {
                    message: response.message,
                },
            });
        }
    });

    protected announceFailureResponse = tap((response: APIResponse<any>) => {
        if (!response.success) {
            this.matSnackBar.openFromComponent(FailureSnackBarComponent, {
                data: {
                    message: response.message,
                },
            });
        }
    });

    protected delayedRetry(delayMs: number = 500, maxRetry: number = 3) {
        return pipe(
            catchError((errorResponse) => {
                if (
                    errorResponse instanceof HttpErrorResponse &&
                    (errorResponse.status === 400 || errorResponse.status === 404)
                ) {
                    Sentry.addBreadcrumb({
                        level: 'error',
                        type: "http",
                        category: "xhr",
                        message: 'API Exception',
                        data: errorResponse,
                    });
                    return of(errorResponse.error);
                } else {
                    throw errorResponse;
                }
            }),
            retry(maxRetry),
            delay(delayMs)
        );
    }
}
